import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetActivity } from '../../../store/ActivityAction';
import TableVertical from '../../misc/TableVertical';
import StatusCode from '../../../util/StatusCode';
import * as Helper from '../../../util/Helper';
import { Link, useParams } from 'react-router-dom'
import { CoreActivity } from '../../../models/CoreActivity';
import { RequestState } from '../../../models/RequestState';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';



const ActivityViewInfo = () => {
    const { t } = useTranslation(['common', 'schoolAdministration'])

    const { activityId } = useParams();
    const dispatch = useDispatch();
    const activity = useSelector<RootState, RequestState<CoreActivity>>(state => state.activities.activity);

    useEffect(() => {
        if (activityId !== undefined) {
            GetActivity(activityId)(dispatch);
        }
    }, [dispatch, activityId]);

    const renderActivityInfo = () => {
        let activityInfo = [];
        if (activity.code === StatusCode.COMPLETE) {
            const a = activity.data;
            activityInfo.push(
                { header: t('commonTableHeaders.title', {ns: 'schoolAdministration'}), content: a.displayName },
                { header: t('activityViewInformationTableHeaders.course', { ns: 'schoolAdministration' }), content: a?.course?.title },
                { header: t('activityViewInformationTableHeaders.subject', { ns: 'schoolAdministration' }), content: a?.subject?.title },
                { header: t('genericTableHeaders.startDate', { ns: 'common' }), content: Helper.formatDateOnly(a.startDate) },
                { header: t('genericTableHeaders.endDate', { ns: 'common' }), content: Helper.formatDateOnly(a.endDate) },
                { header: t('genericTableHeaders.id', { ns: 'common' }), content: a.id },
                { header: t('commonTableHeaders.schoolUnit', { ns: 'schoolAdministration' }), content: <Link to={`/schoolunit/${a.schoolUnit.id}/information`}>{a.schoolUnit.title}</Link> },
                { header: t('activityViewInformationTableHeaders.activityType', { ns: 'schoolAdministration' }), content: t(`activityType.${a.activityType.name}`, {ns: 'schoolAdministration'}) },
                { header: t('genericTableHeaders.active', { ns: 'common' }), content: Helper.active(a.active) },
                { header: t('genericTableHeaders.created', { ns: 'common' }), content: Helper.formatDate(a.created) },
                { header: t('genericTableHeaders.modified', { ns: 'common' }), content: Helper.formatDate(a.modified) },
                { header: t('genericTableHeaders.removed', { ns: 'common' }), content: Helper.formatDate(a?.removed) },
                { header: t('activityViewInformationTableHeaders.calendarEventsRequired', { ns: 'schoolAdministration' }), content: a.calendarEventsRequired ? t('yes', { ns: 'common' }) : t('no', { ns: 'common' }) },
                { header: t('activityViewInformationTableHeaders.comment', { ns: 'schoolAdministration' }), content: a?.comment },
                { header: t('activityViewInformationTableHeaders.minutesPlanned', { ns: 'schoolAdministration' }), content: a?.minutesPlanned },
                { header: t('activityViewInformationTableHeaders.parentActivity', { ns: 'schoolAdministration' }), content: a?.parentActivity },
                { header: t('activityViewInformationTableHeaders.informationMarkings', { ns: 'schoolAdministration' }), content: a?.informationMarkings?.map(marking => `${marking}`).join(", ") },

            )
        }

        return (
            <TableVertical
                header={t('commonTableHeaders.information', { ns: 'schoolAdministration' })}
                info={activityInfo}
                error={activity.code === StatusCode.ERROR}
                searching={activity.code === StatusCode.PENDING}
            />
        )
    }

    return (<>
        {renderActivityInfo()}
    </>)
}

export default ActivityViewInfo;
